/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Outside_AnswerInputs */

const en_scene_outside_answer = /** @type {(inputs: Scene_Outside_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three. The oldest, PO-4498, has waited five days.`)
};

/**
* | output |
* | --- |
* | "Three. The oldest, PO-4498, has waited five days." |
*
* @param {Scene_Outside_AnswerInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_outside_answer = /** @type {((inputs?: Scene_Outside_AnswerInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Outside_AnswerInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_outside_answer(inputs)
});